import * as React from "react";
import { PrescriptionFormInput } from "./PrescriptionFormInput.js";
const PrescriptionFormInputContainer = ({
  parameter,
  selectedValues,
  showValidation,
  parentId,
  validations,
  onAttributeChange,
  isFirstItem,
  isLastItem,
  hideLabels,
  errorMessageId,
  required,
  side
}) => {
  const parameterValue = selectedValues[parameter.name];
  const isParameterValid = showValidation ? validations?.[parameter.name] : void 0;
  return /* @__PURE__ */ React.createElement(
    PrescriptionFormInput,
    {
      side,
      name: parameter.name,
      parentId,
      value: parameterValue,
      isValid: isParameterValid,
      values: parameter.values,
      onChange: onAttributeChange,
      isFirstItem,
      isLastItem,
      hideLabels,
      errorMessageId,
      required
    }
  );
};
export {
  PrescriptionFormInputContainer
};
//# sourceMappingURL=PrescriptionFormInputContainer.js.map
